import React from 'react';
import { Path } from 'app/const/Path';
import { css } from 'styled-components/macro';
import { Typography } from '@material-ui/core';
import { HashLink } from 'react-router-hash-link';

export function NoDataReportedMessage() {
  return (
    <div
      css={css`
        display: flex;
        justify-content: center;
        width: 100%;
        margin-top: 22px;
      `}
    >
      <Typography
        variant="h3"
        color="primary"
        css={css`
          font-size: 12px;
          line-height: 14.5px;
          color: #2e4063;
          font-weight: 400;
        `}
      >
        No data reported by data owner that is compatible with this view. <br />
        For more information please visit:{' '}
        <HashLink
          to={`${Path.general.faq}#question-technical-0`}
          css={`
            font-size: 14px;
            line-height: 20px;
            text-decoration-line: underline;
            color: #2e4063;
            font-weight: 300;
            :hover {
              cursor: pointer !important;
            }
          `}
        >
          FAQ link
        </HashLink>
      </Typography>
    </div>
  );
}
